// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.112.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*=========================================================================================
    File Name: _variables.scss
    Description: partial- SCSS varibales
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

/*========================================================
        SPACING
=========================================================*/

/*========================================================
        COLORS
=========================================================*/

/*========================================================
        TYPOGRAPHY
=========================================================*/

/*========================================================
        TYPOGRAPHY
=========================================================*/

/*========================================================
        DARK THEME
=========================================================*/
[dir] .vx-input-group .vs-con-textarea {
  margin-bottom: 0;
}
[dir=ltr] .vx-input-group .vx-input-group-prepend {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
[dir=rtl] .vx-input-group .vx-input-group-prepend {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.vx-input-group .vx-input-group-prepend .prepend-text {
  display: flex;
  align-items: center;
}
[dir=ltr] .vx-input-group .vx-input-group-prepend .prepend-text:not(:first-child) {
  border-left: 1px solid rgba(0, 0, 0, 0.18);
}
[dir=rtl] .vx-input-group .vx-input-group-prepend .prepend-text:not(:first-child) {
  border-right: 1px solid rgba(0, 0, 0, 0.18);
}
[dir=ltr] .vx-input-group .vx-input-group-prepend .prepend-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
[dir=rtl] .vx-input-group .vx-input-group-prepend .prepend-text:not(:first-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
[dir=ltr] .vx-input-group .vx-input-group-prepend .prepend-text:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
[dir=rtl] .vx-input-group .vx-input-group-prepend .prepend-text:first-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
[dir=ltr] .vx-input-group .vx-input-group-prepend .prepend-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
[dir=rtl] .vx-input-group .vx-input-group-prepend .prepend-text:not(:last-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
[dir=ltr] .vx-input-group .vx-input-group-prepend .prepend-text:last-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
[dir=rtl] .vx-input-group .vx-input-group-prepend .prepend-text:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
[dir=ltr] .vx-input-group .vx-input-group-prepend .prepend-text.btn-addon .vs-button {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
[dir=rtl] .vx-input-group .vx-input-group-prepend .prepend-text.btn-addon .vs-button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
[dir=ltr] .vx-input-group .vx-input-group-prepend .prepend-text.btn-addon .vs-button:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: none;
}
[dir=rtl] .vx-input-group .vx-input-group-prepend .prepend-text.btn-addon .vs-button:not(:first-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
}
[dir=ltr] .vx-input-group .vx-input-group-append {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
[dir=rtl] .vx-input-group .vx-input-group-append {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.vx-input-group .vx-input-group-append .append-text {
  display: flex;
  align-items: center;
}
[dir=ltr] .vx-input-group .vx-input-group-append .append-text:not(:first-child) {
  border-left: 1px solid rgba(0, 0, 0, 0.18);
}
[dir=rtl] .vx-input-group .vx-input-group-append .append-text:not(:first-child) {
  border-right: 1px solid rgba(0, 0, 0, 0.18);
}
[dir=ltr] .vx-input-group .vx-input-group-append .append-text:first-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
[dir=rtl] .vx-input-group .vx-input-group-append .append-text:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
[dir=ltr] .vx-input-group .vx-input-group-append .append-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
[dir=rtl] .vx-input-group .vx-input-group-append .append-text:not(:last-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
[dir=ltr] .vx-input-group .vx-input-group-append .append-text:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
[dir=rtl] .vx-input-group .vx-input-group-append .append-text:last-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
[dir=ltr] .vx-input-group .vx-input-group-append .append-text.btn-addon .vs-button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
[dir=rtl] .vx-input-group .vx-input-group-append .append-text.btn-addon .vs-button {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
[dir=ltr] .vx-input-group .vx-input-group-append .append-text.btn-addon .vs-button:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
}
[dir=rtl] .vx-input-group .vx-input-group-append .append-text.btn-addon .vs-button:not(:last-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: none;
}
.vx-input-group .prepend-text,
.vx-input-group .append-text {
  color: #fff;
}
[dir] .vx-input-group .prepend-text:not(.btn-addon), [dir] .vx-input-group .append-text:not(.btn-addon) {
  border-radius: 6px;
}
[dir=ltr] .vx-input-group .prepend-text:not(.btn-addon), [dir=ltr] .vx-input-group .append-text:not(.btn-addon) {
  padding-left: 1rem;
  padding-right: 1rem;
}
[dir=rtl] .vx-input-group .prepend-text:not(.btn-addon), [dir=rtl] .vx-input-group .append-text:not(.btn-addon) {
  padding-right: 1rem;
  padding-left: 1rem;
}
.vx-input-group .prepend-text.btn-addon .vs-button,
.vx-input-group .append-text.btn-addon .vs-button {
  height: 100%;
}
[dir] .vx-input-group .prepend-text.btn-addon .vs-button, [dir] .vx-input-group .append-text.btn-addon .vs-button {
  padding: 0 1.5rem !important;
}
[dir=ltr] .vx-input-group .vx-input-group-default:not(:first-child) input, [dir=ltr] .vx-input-group .vx-input-group-default:not(:first-child) .vs-con-textarea {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
[dir=rtl] .vx-input-group .vx-input-group-default:not(:first-child) input, [dir=rtl] .vx-input-group .vx-input-group-default:not(:first-child) .vs-con-textarea {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.vx-input-group .vx-input-group-default .vs-input {
  width: 100%;
}
[dir=ltr] .vx-input-group .vx-input-group-default:not(:last-child) input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
[dir=rtl] .vx-input-group .vx-input-group-default:not(:last-child) input {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
